function inWords(date) {
  const diff = (Date.now() - date) / 1000
  const abs = Math.abs(diff)
  const minutes = abs / 60
  const hours = minutes / 60
  const days = hours / 24
  const years = days / 365
  const sub = (str, n) => str.replace("%d", n)
  const pre = diff < 0 ? "in" : "vor"

  let word
  if (abs < 45) word = "wenigen Sekunden"
  else if (abs < 90) word = "etwa einer Minute"
  else if (minutes < 45) word = sub("%d Minuten", Math.round(minutes))
  else if (minutes < 90) word = "etwa einer Stunde"
  else if (hours < 24) word = sub("%d Stunden", Math.round(hours))
  else if (hours < 42) word = "etwa einem Tag"
  else if (days < 30) word = sub("%d Tagen", Math.round(days))
  else if (days < 45) word = "etwa einem Monat"
  else if (days < 365) word = sub("%d Monaten", Math.round(days / 30))
  else if (years < 1.5) word = "etwa einem Jahr"
  else word = sub("%d Jahren", Math.round(years))

  return `${pre} ${word}`
}

export function initTimeago() {
  for (const el of document.querySelectorAll("abbr.timeago")) {
    const date = new Date(el.getAttribute("title"))
    if (!Number.isNaN(date)) el.textContent = inWords(date)
  }
}
